<div class="share-control">
  <div class="share-control__checkbox" [class.disabled]="!canManage">
    <mat-checkbox
      [checked]="isShared"
      [disabled]="!canManage || isLoading"
      (change)="onShareToggle($event.checked)">
      {{ 'Share Template' | translate }}
    </mat-checkbox>
  </div>

  @if (isShared && organizationLevels.length > 0 && !isLoading) {
    <div class="share-control__org-level">
      <label class="share-control__label">{{ 'Visibility' | translate }}</label>
      <mat-form-field appearance="outline" class="share-control__select">
        <mat-select
          [value]="organizationLevelId"
          (valueChange)="onOrgLevelChange($event)">
          @for (orgLevel of organizationLevels; track trackById($index, orgLevel)) {
            <mat-option [value]="orgLevel.id">
              {{ orgLevel.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
</div>
